// extracted by mini-css-extract-plugin
module.exports = {"header":"text-range-box_header__4I3rn","value":"text-range-box_value__1VlHn","invalidInput":"text-range-box_invalidInput__1VM_F"};